<template>
    <v-container>
        <v-card>
            <v-card-title>
                <span class="display-1">Informes</span>
                <v-spacer></v-spacer>
            </v-card-title>
            <!--FILTRO-->
            <div class="mb-4 mt-2 pl-3 pr-3">
                <v-row class="justify-center">      
                    <v-col cols="12" md="2">
                        <v-menu v-model="fechaInicioInput" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="fechaInicio"
                                    label="Día de informe"
                                    prepend-icon="mdi-calendar"
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker locale = "es-ES" first-day-of-week="1" v-model="fechaInicio" @input="fechaInicioInput = false"></v-date-picker>
                        </v-menu>
                    </v-col> 
                    <!-- <v-col cols="12" md="2">
                        <v-menu v-model="fechaFinInput" :close-on-content-click="false" 
                        :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="fechaFin"
                                    label="Fecha Fin"
                                    prepend-icon="mdi-calendar"
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="fechaFin" @input="fechaFinInput = false"></v-date-picker>
                        </v-menu>
                    </v-col> -->
                </v-row>  
                <v-row>       
                    <v-col cols="12" class="text-center"> 
                        <v-btn @click="getInforme"
                        block
                        color="primary">
                            <v-icon>CREAR</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>

                <!-- Informe creado -->
                <v-row v-if="creado">
                    <v-col cols="12">
                        <v-data-table :items="items" :headers="headers" hide-default-footer :loading="loading">
                            <!-- Tiempo de secado total -->
                            <template v-slot:[`item.t_secado_total`]="{ item }">
                                <div v-if="item.conseguido_todos">
                                    {{ calcularTiempoSecadoTotal() }}
                                </div>
                                <div v-else>
                                    Calculando... {{ ciclo_obtenido }}
                                </div>
                            </template>
                            
                            <!-- Tiempo parado total -->
                            <template v-slot:[`item.t_parado_total`]="{ item }">
                                <div v-if="item.conseguido_todos">
                                    {{ calcularTiempoParadoTotal() }}
                                </div>
                                <div v-else>
                                    Calculando... {{ ciclo_obtenido }}
                                </div>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>

                <v-row v-show="ciclo_obtenido > 0 && ciclo_obtenido == datos.length">
                    <v-col cols="12">
                        Temperatura Salida
                        <line-chart :chart-data="datosGrafico"></line-chart>
                    </v-col>
                </v-row>
                <v-row v-show="ciclo_obtenido > 0 && ciclo_obtenido == datos.length">
                    <v-col cols="12">
                        <v-data-table :items="diferencias()" :headers="headers_diferencias" hide-default-footer disable-pagination>
                            <!-- <template v-slot:item.id="{ item }">
                                {{ fechaInicio }}-{{ item.id+1 }}
                            </template> -->
                            <<template v-slot:[`item.f_inicio`]="{ item }">
                                {{ getHour(item.f_inicio) }}
                            </template>
                            <<template v-slot:[`item.f_fin`]="{ item }">
                                {{ getHour(item.f_fin) }}
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </v-container>
</template>

<script>
import moment from 'moment-timezone';
import LineChart from '../components/LineChartV2.vue'
import { mapActions } from 'vuex';
export default {
    components: {
        LineChart
    },
    data() {
        return {
            //fechaInicio: this.getDate(moment(new Date().now).subtract(1, 'days')), //Ayer
            fechaInicio: this.getDate(), //Hoy
            // fechaFin: this.getDate(),
            fechaInicioInput: false,
            fechaFinInput: false,
            creado: false,
            loading: false,
            datos: [],
            items: [],
            headers: [
                { text: "Día", align: "center", value: "dia"},
                { text: "Inicio", align: "center", value: "inicio"},
                { text: "Fin", align: "center", value: "fin"},
                { text: "Número de ciclos", align: "center", value: "n_ciclos"},
                { text: "Tiempo de secado total", align: "center", value: "t_secado_total"},
                { text: "Tiempo total fuera de ciclo", align: "center", value: "t_parado_total"},
            ],
            ciclo_obtenido: 0,
            t_entre_ciclos: [],
            headers_diferencias: [
                { text: "Intervalo", align: "center", value: "id"},
                { text: "Inicio", align: "center", value: "f_inicio"},
                { text: "Fin", align: "center", value: "f_fin"},
                { text: "Tiempo pasado hasta el siguiente ciclo", align: "center", value: "diff"},
            ],
            ciclo_intermedio: false,
            finCicloIntermedio: 0,
        }
    },
    watch: {
        ciclo_obtenido(){
            if(this.ciclo_obtenido == this.datos.length && this.ciclo_obtenido > 0){
                this.items[0].conseguido_todos = true
                this.items.splice()
            }
        },
    },
    computed: {
        datosGrafico(){
            let nuevo = {
                labels:[],
                datasets: [
                    {
                        data: [],
                        segment: {
                            borderColor: ctx => this.choosePhaseColor(ctx),
                        },
                        pointRadius: 0, //No pintar los puntos (para que solo se vea la linea)
                    },
                ]
            }
            //Recorrer array de datos (todos los ciclos)
            //Entrar una vez cargados todos los ciclos
            if(this.datos.length == this.ciclo_obtenido && this.ciclo_obtenido > 0){
                this.t_entre_ciclos = []
                //Primer punto siempre a las 6am
                if(!this.ciclo_intermedio){
                    const primero = moment(this.fechaInicio+' 06:00:00').local()
                    nuevo.datasets[0].data.push({ 'x': primero, 'y': 75, 'fase': 6 })
                    nuevo.labels.push(primero)
                    this.t_entre_ciclos.push(primero)
                }else{
                    const primero = moment(this.finCicloIntermedio).local()
                    nuevo.datasets[0].data.push({ 'x': primero, 'y': 75, 'fase': 6 })
                    nuevo.labels.push(primero)
                    this.t_entre_ciclos.push(primero)
                }

                this.datos.forEach(e => {
                    this.t_entre_ciclos.push(e.datos_de_ensayo[0].date)
                    let t = e.datos_de_ensayo[0].date
                    nuevo.datasets[0].data.push({ 'x': t, 'y': 75, 'fase': 6 })
                    
                    //Recorremos cada ciclo
                    e.datos_de_ensayo.forEach(p => {
                        t = p.date
                        nuevo.datasets[0].data.push({ 'x': t, 'y': p.temperatura_salida, 'fase': p.phase })
                        nuevo.labels.push(t)
                    });
                    nuevo.datasets[0].data.push({ 'x': t, 'y': 75, 'fase': 6 })
                    this.t_entre_ciclos.push(t)
                })

                // const ultimo = moment(this.fechaInicio+' 06:00:00').local().add(1,'days')
                // nuevo.datasets[0].data.push({ 'x': ultimo, 'y': 75, 'fase': 6 })
                // nuevo.labels.push(ultimo)
                
                // this.t_entre_ciclos.push(ultimo)
            }
            return nuevo
        },
    },
    methods: {
        ...mapActions(['getData']),
        getDate(date = new Date().now){
            return moment(date).format('YYYY-MM-DD')
        },
        getHour(date = new Date().now){
            return moment(date).format('HH:mm:ss')
        },
        choosePhaseColor: (ctx) => {
            if (ctx.p0.raw.fase == ctx.p1.raw.fase) {
                if ([2].includes(ctx.p1.raw.fase)) return '#FF9800'
                if ([4].includes(ctx.p1.raw.fase)) return '#99ff33'
                if ([6].includes(ctx.p1.raw.fase)) return '#333333'
                else return '#2196F3'
            } else {
                // return '#FF9800'
            }
        },
        getInforme(){            
            this.datos = []
            this.items = []
            this.ciclo_obtenido = 0
            this.getDatosEnsayos()
            this.creado = true
        },
        getDatosEnsayos(){
            this.loading = true
            
            const firstDay = this.fechaInicio
            const lastDay = moment(this.fechaInicio).add(1,'days').format('YYYY-MM-DD')

            const params= {
                firstDay,
                lastDay: lastDay,
                lote_mp: null,
                lote_bolson: null,
                lote_membrana: null,
                worker: null
            }
            console.log('Pido desde ' + firstDay + ' hasta ' + params.lastDay);

            // this.axios.get('/get-historico-ensayos', {
            //         params,
            //         headers: { "token": localStorage.getItem('token') }
            // })
            const payload = {
                path: 'ciclos/get-historico-ensayos',
                params:{
                    firstDay,
                    lastDay: lastDay,
                    lote_mp: null,
                    lote_bolson: null,
                    lote_membrana: null,
                    worker: null
                }
            }
            this.getData(payload)
            .then(res => {
                console.log('res.results');
                console.log(res.results);
                this.datos = res.results
                
                this.cicloAnterior6am()

                const resumen = {
                    dia: this.fechaInicio,
                    inicio: this.fechaInicio + ' 06:00:00',
                    fin: lastDay + ' 05:59:59',
                    n_ciclos: this.datos.length
                }
                this.items.push(resumen)
                this.loading = false
                
                //Datos de cada ciclo
                this.datos.map(er=>er['conseguido']=false)
                this.datos.forEach(element => {

                    // this.axios.get('/get-historico-ciclo',
                    // {
                    //     params: {
                    //         ciclo: element['id_ensayo']
                    //     },
                    //     headers: { "token": localStorage.getItem('token') }
                    // })
                    const payload = {
                        path: 'ciclos/get-historico-ciclo',
                        params: {
                            ciclo: element['id_ensayo']
                        } 
                    }
                    this.getData(payload)
                    .then(res => {
                        element['datos_de_ensayo']=res.results;
                        this.ciclo_obtenido += 1
                        this.datos.splice();
                    })
                })
            })

            this.loading = false
        },
        cicloAnterior6am(){
            //Comprobar is hay valores entre las 6am y el primer tiempo donde empieza el primer ciclo que tenemos
            let primerCiclo = moment(this.datos[0].fechahora_ensayo).local().format('YYYY-MM-DD HH:mm:ss')
            console.log('cicloAnterior6am');
            console.log(primerCiclo);

            //Pedir al back datos de ciclo entre 6am y "primerCiclo"
            let inicio = moment(this.fechaInicio+' 06:00:00').local().format('YYYY-MM-DD HH:mm:ss')
            console.log(inicio);
            let params = {
                inicio: inicio,
                fin: primerCiclo
            }
            // this.axios.get('/get-ciclo-intermedio', {
            //     params,
            //     headers: { "token": localStorage.getItem('token') }

            const payload = {
                path: 'ciclos/get-ciclo-intermedio',
                params: {
                    inicio: inicio,
                    fin: primerCiclo
                }
            }
            this.getData(payload)
            .then(res => {
                console.log('res');
                console.log(res);
                if(res.results.length > 0){
                    this.ciclo_intermedio = true
    
                    //Sumamos un ciclo total más
                    this.items[0].n_ciclos += 1
                    const item = {
                        conseguido: true,
                        datos_de_ensayo: res.results
                    }
                    this.finCicloIntermedio = res.results[res.results.length - 1].date
                    this.datos.push(item)
                    this.datos.splice();
                    this.ciclo_obtenido += 1
                }
            })
        },
        calcularTiempoSecadoTotal(){
            let t_total = 0
            this.datos.forEach(element => {
                t_total += this.calcularTiempoSecado(element.datos_de_ensayo)
            });
            return this.segundosAminutos(t_total)
        },
        calcularTiempoSecado(lista) {
            let result = []
            lista.map(item => {
                if(item.phase == '2'){
                    result.push(item)
                }
            })
            return result.length
        },
        segundosAminutos(duration){   
            // Hours, minutes and seconds
            var hrs = ~~(duration / 3600);
            var mins = ~~((duration % 3600) / 60);
            var secs = ~~duration % 60;

            // Output like "1:01" or "4:03:59" or "123:03:59"
            var ret = "";

            if (hrs > 0) {
                ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
            }

            ret += "" + mins + ":" + (secs < 10 ? "0" : "");
            ret += "" + secs;
            return ret;
        },
        calcularTiempoParadoTotal(){
            //Día total en segundos menos cantidad de puntos(1 por segundo) = length puntos por ciclo
            let t_total = 0
            this.datos.forEach(element => {
                t_total += element.datos_de_ensayo.length
            });

            return this.segundosAminutos(24*60*60 - t_total)
        },
        diferencias(){
            let diff = []
            let indice = 1
            for (let i = 0; i < this.t_entre_ciclos.length; i++) {
                if(i % 2 == 0){
                    let a = new Date(this.t_entre_ciclos[i+1]).getTime() - new Date(this.t_entre_ciclos[i]).getTime()
                    if(a > 0) diff.push({id: indice, f_inicio: this.t_entre_ciclos[i], f_fin: this.t_entre_ciclos[i+1], diff: this.segundosAminutos(a/1000)})
                    else diff.push({id: indice, f_inicio: this.t_entre_ciclos[i], f_fin: this.t_entre_ciclos[i+1], diff: 0})
                    indice += 1
                }
            }
            //Si existe un ciclo intermedio (entre 6am y los del día) eliminamos el último para no mostrarlo
            if(this.ciclo_intermedio) diff.pop()
            return diff
        },
    },
}
</script>
<style>
    
</style>